<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            :parentData="parentData"
            modalWidth="90%"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Fecha inicio')">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['init_date', { rules: [{ required: false, message: 'Valor requerido'}] }]"
            ></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown endpoint="hierarchy_lookup"
                      :label="$t('Tipo de reintegro')"
                      style="width: 100%"
                      :formItemConfig="fiOptions"
                      :decorator="['id_h_refund_type', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                      :params="tipo_reintegro">
          </g-dropdown>
        </a-col>
        <!--<a-col v-bind="colOptions">
          <g-dropdown v-bind="fiOptions"
                      endpoint="legal_entities"
                      :label="$t('IPS')"
                      :formItemConfig="fiOptions"
                      :params="legal_entities"
                      :decorator="['ent_id', { rules: [{ required: false}] }]"
          >
          </g-dropdown>
        </a-col>-->
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('IPS')" v-bind="fiOptions">
            <a-textarea autoSize
                        v-decorator="['entity', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Recomendaciones')" v-bind="fiOptions">
            <a-textarea autoSize
                        v-decorator="['obs', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Fecha fin vigencia')">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['end_date', { rules: [{ required: false, message: 'Valor requerido'}] }]"
            ></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Fecha Reinduccion')">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['end_date_reinduction', { rules: [{ required: false, message: 'Valor requerido'}] }]"
            ></a-date-picker>
          </a-form-item>
        </a-col>
        <!--<a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Fecha Reinduccion HSEQ')">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['init_date_reinduction', { rules: [{ required: false, message: 'Valor requerido'}] }]"
            ></a-date-picker>
          </a-form-item>
        </a-col>-->
      </a-row>
    </template>
  </g-master>
</template>

<script>
  export default {
    props: ['id_case'],
    data () {
      return {
        legal_entities: {
          legal_entities_absen: true
        },
        tipo_reintegro: {
          h_lookup_type: 'TIPO_REINTEGRO'
        },
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          endpoint: 'post_absen_cases',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Fecha inicio', dataIndex: 'init_date_desc', sorter: true},
              {title: 'IPS', dataIndex: 'entity', sorter: true},
              {title: 'Fecha Reinduccion', dataIndex: 'init_date_reinduction_desc', sorter: true},
              {title: 'Fecha Reinduccion HSEQ', dataIndex: 'end_date_reinduction_desc', sorter: true},
              {title: 'Tipo de reintegro', dataIndex: 'h_refund_type', sorter: true},
              {title: 'Recomendaciones', dataIndex: 'obs', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'obs'},
            {name: 'end_date'},
            {name: 'end_date_reinduction'},
            {name: 'ent_id'},
            {name: 'id_case'},
            {name: 'id_h_refund_type'},
            {name: 'init_date'},
            {name: 'init_date_reinduction'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {id_case: this.id_case}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/ExamenPostincapacidad.vue